import { render, staticRenderFns } from "./BreadCumb.vue?vue&type=template&id=e2836714&scoped=true"
import script from "./BreadCumb.vue?vue&type=script&lang=js"
export * from "./BreadCumb.vue?vue&type=script&lang=js"
import style0 from "./BreadCumb.vue?vue&type=style&index=0&id=e2836714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2836714",
  null
  
)

export default component.exports